import { API_BASE } from "@/config/api";
import { SITE_TEXTS, type SiteTextKey } from "@/lib/siteTexts";

export function siteTextDefault(key: SiteTextKey): string {
  return SITE_TEXTS.find((d) => d.key === key)?.default ?? "";
}

export async function readTextOverrides(): Promise<Record<string, string>> {
  const res = await fetch(`${API_BASE}/bootstrap`);
  const json = await res.json();
  return json.contentBlocks?.textos?.site?.[0]?.values ?? {};
}

// Guarda unos pocos textos de "Textos del sitio" sin tocar los demás que ya estén modificados.
// Un texto igual al original se quita de lo guardado, así el sitio vuelve a usar el original.
export async function saveTextOverrides(values: Partial<Record<SiteTextKey, string>>): Promise<boolean> {
  const merged = await readTextOverrides();
  for (const [key, value] of Object.entries(values) as [SiteTextKey, string][]) {
    if (value === siteTextDefault(key)) delete merged[key];
    else merged[key] = value;
  }
  const res = await fetch(`${API_BASE}/content-blocks/textos/site`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: "config", values: merged }] }),
  });
  return res.ok;
}
